import React from 'react';
import TextAdapter from './TextAdapter';
import { AdapterProps } from '../types';

const PasswordAdapter = (props: AdapterProps['email']) => (
  <TextAdapter type="email" {...props} />
);

export default PasswordAdapter;
